<template>
  <div>
    <div class="flex w-full items-center justify-center h-screen">
      <div class="sm:block w-1/2 bg-cover h-screen" style='background: url(register-bckg-1.jpg)' >
        <div class="bg-blue-800 w-full h-screen bg-opacity-20">
        </div>
      </div>
      <div class="sm:w-1/2">
        <div class="p-5 w-4/5 mx-auto text-left font-raleway">
          <div class="text-left mb-10"> 
            <router-link to="/login">
                <font-awesome-icon class="mr-5" :icon="['fas', 'arrow-left']" /> Login
            </router-link> 
          </div>
          <h1 class="font-bold text-left font-montserrat text-4xl sm:text-6xl mb-10">
              Dein. eduBB. Register
          </h1>
          <div v-if="done">
            <section>
              <p v-show="done" class="text-sm text-green-500">Registrierung erfolgreich</p>
              <b-message type="is-success" has-icon>
              </b-message>
              <b-message type="is-success" has-icon>
                Danke für die Registrierung! Sie erhalten eine Email. Bitte klicken Sie auf den Link in der Email um die Registierung zu bestätigen. Sie werden danach automatisch auf die Login Seite von eduBB weitergeleitet.
        </b-message>
            </section>
          </div>
          <div v-else>
          <p v-show="error" class="text-sm text-red-500">
            Ein Fehler ist aufgetreten. Verwenden Sie einen anderen Namen und stellen Sie sicher, dass Sie nicht bereits einen Account mit dieser Email angelegt haben! Bei Fragen, nutzen Sie unseren Chat oder hinterlassen Sie dort eine Nachricht.</p>
          <div class="card-body">
            <form action="#" @submit.prevent="submit">
              
                <div class="my-5">
                  <label for="name" class="col-md-4 col-form-label text-md-right"
                    >Name</label
                  >
                  <div class="col-md-6">
                    <input
                      id="name"
                      type="name"
                      class="outline-none bg-transparent border-b hover:border-blue-700 focus:border-blue-700"
                      name="name"
                      value
                      required
                      autofocus
                      v-model="form.name"
                    />
                  </div>
                </div>
                <!-- Form field Email -->
                <div class="form-group row">
                  <div class="my-5">
                  
                <label for="email" class="col-md-4 col-form-label text-md-right"
                  >Email</label
                >

                <div class="col-md-6">
                  <input
                    id="email"
                    type="email"
                    class="outline-none bg-transparent border-b hover:border-blue-700 focus:border-blue-700"
                    name="email"
                    value
                    required
                    autofocus
                    @input="clearError"
                    v-model="form.email"
                  />
                </div>
              </div>
              </div>
          
              <div class="form-group row">
                <label
                  for="password"
                  class="col-md-4 col-form-label text-md-right"
                  >Password</label
                >

                <div class="my-5">
                  <input
                    id="password"
                    :type="showPassword ? 'text' : 'password'"
                    class="outline-none bg-transparent border-b hover:border-blue-700 focus:border-blue-700"
                    name="password"
                    password-reveal
                    required
                    :minlength="6"
                    @input="clearError"
                    v-model="form.password"
                  />
                </div>
                <label for="showPassword" class="ml-2">
                  <input
                    id="showPassword"
                    type="checkbox"
                    v-model="showPassword"
                    @click="togglePasswordVisibility"
                  />
                  Passwort anzeigen
                </label>
              </div>
              <br>

              <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-4">
                  <section>
                    <b-field>
                      <b-checkbox 
                      v-model="form.checkboxAGB"
                      :value="false"
                      type="is-info"
                      @click="form.checkboxAGB = !form.checkboxAGB" 
                      >
                          AGBs gelesen
                      </b-checkbox>
                      
                      <b-button tag="a"
                      href="https://myedubbosz01.s3.eu-central-1.amazonaws.com/AGB_Portal_Kompetenznetzwerk_5dfd73114c.pdf"
                      target="_blank"
                      type="is-info is-light">
                      AGB lesen
                    </b-button>
                   
                    </b-field>
                    <div v-if="!form.checkboxAGB" class="buttons">
                      <b-tooltip label="Bitte die AGB lesen und bestätigen" position="is-bottom"
                      always>
                        <button :disabled="isDisabled" class="py-1 px-4 rounded-full">
                        Registrieren <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" />
                        </button>
                      </b-tooltip>
                    </div>
                    <div v-else>
                    <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full">
                      Registrieren <font-awesome-icon class="ml-3" :icon="['fas', 'arrow-right']" />
                    </button>
                  </div>
               
                </section>
                </div>
              </div>
             
            </form>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { createUserWithEmailAndPassword } from "firebase/auth";
import axios from 'axios'

export default {
  name: 'Register',
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        checkboxAGB: false
      },
      API_URL:
      process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "http://localhost:1338",
      isPasswordVisible: false,
      error: false,
      done: false,
      showPassword: false,
    };
  },
  computed: {
    isDisabled: function(){
        return !this.name || !this.email || !this.password
    }
  },
  methods: {
    clearError() {
      this.error = false;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        setTimeout(() => {
          this.showPassword = false;
        }, 3000);
      }
    },
    async submit() {
      try{
        const username = this.form.name
        const email = this.form.email;
        const password = this.form.password;

        const data = {
          email,
          password,
          username,
          user_permissions: [
            {
              id: 1,
              key: 'public'
            }
          ]
        }

        await axios({
          method: 'POST',
          url: `${this.API_URL}`+ `/auth/local/register`,
          data
        }).then( (response) => {
          // Handle Success register email send
          console.log("response user reg",response)
          this.done = true
          this.error = false
          const data2 = {
            email
          }

          axios({
          method: 'POST',
          url: `${this.API_URL}`+ `/auth/local/send-email-confirmation`,
          data2
            }).then( () => {
             
              // Handle Success Confirmation email send
            })
          })
        }catch(err){
          this.error = true
          console.log(err)
         
            this.$buefy.toast.open('Fehler beim Registrieren');
          
        }

      // THis ist with Firebase Auth
/*       createUserWithEmailAndPassword(this.form.email, this.form.password)
        .then((data) => {
          data.user
            .updateProfile({
              displayName: this.form.name,
            })
            .then(() => {});
        })
        .catch((err) => {
          this.error = err.message;
        }); */


    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
</style>
